// extracted by mini-css-extract-plugin
export default {"selected":"_50412f1ea3","un":"_097bae900c"};